export var CROSS_FLOW_CHANNEL = 'crossFlow';
export var eventTypes = /*#__PURE__*/function (eventTypes) {
  eventTypes["UI"] = "ui";
  eventTypes["SCREEN"] = "screen";
  return eventTypes;
}({});